import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import "./home.css";

function Home() {
  const latestUpdates = [
    "Senior State Championships 2026 details announced! Click here to view.",
    //"North-Zone Open Junior Badminton Championship 2025 results are out! Click here to view.",
    //"Sanjeev Kumar wins Gold at Khelo India Para Nationals! Read the updates."
  ];

  return (
    <div className="home-container">
      {/* Hero Banner Section */}
      <div className="hero-banner">
        <h1 className="text-uppercase">Chandigarh Badminton Association</h1>
        <p className="lead">Affiliated to Badminton Association of India</p>
        <div className="d-flex gap-3 mt-2">
          <Link to="/CBA_ID" className="btn btn-yonex-green px-4 py-2 text-uppercase">
            CBA ID Directory
          </Link>
          <Link to="/events" className="btn btn-yonex-outline border-white text-white px-4 py-2 text-uppercase">
            View Tournaments
          </Link>
        </div>
      </div>

      {/* Notice Board Ticker */}
      <div className="ticker-wrapper">
        <div className="ticker-label">
          <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16" className="me-1">
            <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
          </svg>
          Updates
        </div>
        <div className="ticker-content-box">
          <div className="ticker-scroller">
            {latestUpdates.map((update, index) => (
              <span key={index} className="mx-4"><span className="red-items">
                Latest Updates: &nbsp; </span> 
                <Link to="/events" className="ticker-item">
                 {update}
                </Link>
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="container py-5">
        <Row className="gy-4 align-items-center mb-5">
          <Col lg={7}>
            <h2 className="home-section-title">Welcome to CBA</h2>
            <p className="home-intro-text">
              Welcome to the official website of the <strong>Chandigarh Badminton Association (CBA)</strong>, a proud affiliate of the Badminton Association of India. Our association is committed to making badminton accessible to all by fostering a vibrant community of players, enthusiasts, and supporters.
            </p>
            <p className="home-intro-text">
              With a mission to nurture talent and promote the sport across all age groups, CBA has been pivotal in organizing state-level championships, training camps, and grassroots programs that encourage widespread participation.
            </p>
            <p className="home-intro-text">
              We are dedicated to creating an environment where budding athletes can develop their skills and compete at the highest level. Our highly skilled team, led by Patron Priyank Bharti (IAS) and President Vijayendra Kumar (IAS), supported by experienced advisors, coaches, and committee members, works tirelessly to ensure that players receive the best training, facilities, and opportunities.
            </p>
          </Col>
          <Col lg={5} className="ps-lg-5">
            <div className="p-4 bg-white rounded shadow-sm border-start border-4 border-primary">
              <h4 className="fw-bold mb-3 text-gradient">Our Key Mission</h4>
              <ul className="list-unstyled mb-0">
                <li className="d-flex align-items-start mb-3">
                  <span className="badge bg-success me-2 mt-1">✓</span>
                  <span>Grassroots level player development & training camps.</span>
                </li>
                <li className="d-flex align-items-start mb-3">
                  <span className="badge bg-success me-2 mt-1">✓</span>
                  <span>Organizing structured state & regional championships.</span>
                </li>
                <li className="d-flex align-items-start mb-3">
                  <span className="badge bg-success me-2 mt-1">✓</span>
                  <span>Managing state-of-the-art sports facilities.</span>
                </li>
                <li className="d-flex align-items-start">
                  <span className="badge bg-success me-2 mt-1">✓</span>
                  <span>Affording players platforms for national & international selection.</span>
                </li>
              </ul>
            </div>
          </Col>
        </Row>

        {/* Quick Links Section */}
        <h3 className="home-section-title text-center center mb-4">Quick Navigation</h3>
        <Row className="g-4">
          <Col md={4}>
            <Card className="quick-action-card p-4">
              <Card.Body className="d-flex flex-column align-items-center text-center p-0">
                <div className="card-icon-wrapper">
                  <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8Zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022ZM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.047 1.077-2.84.18-.204.383-.386.6-.547ZM5 4a2 2 0 1 0-2 2 2 0 0 0 2-2Zm1.613 2.193a2.987 2.987 0 0 1-.502-.875A3.486 3.486 0 0 1 3 5.5a3.5 3.5 0 0 1-1.387-.284A2.99 2.99 0 0 1 0 4.193a3 3 0 0 1 5.387-2.022 3 3 0 0 1 1.613 2.193ZM6 8a3.3 3.3 0 0 0-1 .15A5.6 5.6 0 0 0 3.1 9c-1.3.4-2.1 1.2-2.1 2H6V8Z"/>
                  </svg>
                </div>
                <Card.Title className="fw-bold mb-2">Player CBA Directory</Card.Title>
                <Card.Text className="text-muted mb-4 small">
                  Verify registration details and check official player IDs in the state database.
                </Card.Text>
                <Link to="/CBA_ID" className="btn btn-yonex-blue w-100 mt-auto">
                  Search CBA ID
                </Link>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="quick-action-card card-alt p-4">
              <Card.Body className="d-flex flex-column align-items-center text-center p-0">
                <div className="card-icon-wrapper">
                  <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                  </svg>
                </div>
                <Card.Title className="fw-bold mb-2">Events & Notices</Card.Title>
                <Card.Text className="text-muted mb-4 small">
                  Get the latest entry forms, tournament draws, circulars, and schedules.
                </Card.Text>
                <Link to="/events" className="btn btn-yonex-green w-100 mt-auto">
                  View Announcements
                </Link>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="quick-action-card p-4">
              <Card.Body className="d-flex flex-column align-items-center text-center p-0">
                <div className="card-icon-wrapper">
                  <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
                    <path d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zm-12 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-10a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1zm7.19-7.312a.5.5 0 0 0-.762-.024l-3.5 4a.5.5 0 0 0 .048.722c.16.14.39.123.535-.042l3.208-3.666 4.02 4.02a.5.5 0 0 0 .708-.708l-4.25-4.25z"/>
                  </svg>
                </div>
                <Card.Title className="fw-bold mb-2">Media Gallery</Card.Title>
                <Card.Text className="text-muted mb-4 small">
                  See photos of training sessions, opening ceremonies, and championship wins.
                </Card.Text>
                <Link to="/gallery" className="btn btn-yonex-blue w-100 mt-auto">
                  Browse Gallery
                </Link>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Home;
